import { render, staticRenderFns } from "./MealToComponent.vue?vue&type=template&id=e788d970&"
import script from "./MealToComponent.vue?vue&type=script&lang=js&"
export * from "./MealToComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports